import React, { useState, useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const [broshuraOpen, setBroshuraOpen] = useState(false);

  useEffect(() => {
    ScrollTrigger.create({
      trigger: ".banner-bg",
      start: `top+=${window.innerWidth * 2.1} top`, // Waits until the last section is done
      end: "bottom top",
      onEnter: () => {}, // Changes only when vertical scrolling starts
      onEnterBack: () => {}, // Resets when scrolling back up
    });
  }, []);

  useEffect(() => {
    if (isOpen) {
      gsap.to(".sliding-menu", { x: 0, duration: 0.5, ease: "power3.out" });
      gsap.to(".line-1", { rotate: 44, y: 4, duration: 0.3, ease: "power3.out" });
      gsap.to(".line-2", { rotate: -36, y: -3, duration: 0.3, ease: "power3.out" });
    } else {
      gsap.to(".sliding-menu", { x: "-100%", duration: 0.5, ease: "power3.in" });
      gsap.to(".line-1", { rotate: 0, y: 0, duration: 0.3, ease: "power3.in" });
      gsap.to(".line-2", { rotate: 0, y: 0, duration: 0.3, ease: "power3.in" });
      setBroshuraOpen(false);
    }
  }, [isOpen]);

  return (
    <>
      <nav className="w-full fixed p-5 px-10 lg:px-20 grid grid-cols-12 z-50 bg-[#00000070]">
        {/* Left Logo */}
        <div className="col-span-6 flex items-center">
          <a href="/"><img className="w-[30vw] md:w-[20vw] lg:w-[10vw]" src="/images/hitPNG.png" alt="Logo" /></a>
        </div>

        {/* Right Button (Triggers the Sliding Menu) */}
        <div className="col-span-6 flex flex-col items-end justify-center h-full">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className=" cursor-pointer"
        >
          <div className="line-1 h-[2px] bg-white w-[25px] mb-[5px]"></div>
          <div className="line-2 h-[2px] bg-white w-[25px]"></div>
        </button>
        </div>
      </nav>

      {/* Sliding Fullscreen Menu */}
      <div
        className="sliding-menu flex flex-col gap-5 pl-20 pt-[20vh]  fixed top-0 left-0 w-full h-full bg-black z-40"
        style={{ transform: "translateX(-100%)" }} // Initially hidden
      >
          <p className="text-white text-2xl md:text-3xl lg:text-3xl montserrat font-medium"><a href="/">BALLINA</a></p>
          <p className="text-white text-2xl md:text-3xl lg:text-3xl montserrat font-meidum"><a href="/about">RRETH NESH</a></p>
          <p className="text-white text-2xl md:text-3xl lg:text-3xl montserrat font-meidum"><a href="/services">SHERBIMET TONA</a></p>
          <p className="text-white text-2xl md:text-3xl lg:text-3xl montserrat font-meidum"><a href="/videos">VIDEOT</a></p>
          <p className="text-white text-2xl md:text-3xl lg:text-3xl montserrat font-meidum"><a href="/vizualizimet">VIZUALIZIMET</a></p>
          <p className="text-white text-2xl md:text-3xl lg:text-3xl montserrat font-meidum"><a href="/contact">KONTAKTI</a></p>
          {/* BROSHURA me opsione lart */}
          {broshuraOpen && (
            <div className="flex flex-col gap-3 pl-8 border-l-2 border-red-600 ml-1">
              <a
                href="/flipbook34"
                onClick={() => { setBroshuraOpen(false); setIsOpen(false); }}
                className="text-white text-xl md:text-2xl lg:text-2xl montserrat font-medium hover:main-red-color transition-colors"
              >
                Lamella 3/4
              </a>
              <a
                href="/flipbook"
                onClick={() => { setBroshuraOpen(false); setIsOpen(false); }}
                className="text-white text-xl md:text-2xl lg:text-2xl montserrat font-medium hover:main-red-color transition-colors"
              >
                Lamella 5/6
              </a>
            </div>
          )}
          <p
            className="main-red-color text-2xl md:text-3xl lg:text-3xl montserrat font-meidum cursor-pointer select-none flex items-center gap-3"
            onClick={() => setBroshuraOpen(!broshuraOpen)}
          >
            BROSHURA
            <span className="text-base">{broshuraOpen ? "▲" : "▼"}</span>
          </p>

      </div>
    </>
  );
}

export default Navigation;
